import React from "react";
import { Form, Input, InputNumber, Select, Switch } from "antd";
import { IconStar } from "@tabler/icons-react";

export default function BasicSection({ issuerOptions, categoryOptions }) {
  return (
    <>
      <Form.Item
        name="issuerId"
        label="Байгууллага"
        rules={[{ required: true, message: "Байгууллага сонгоно уу" }]}
      >
        <Select
          allowClear
          showSearch
          placeholder="Даатгалын компани сонгох"
          filterOption={(input, option) =>
            option.label.toLowerCase().includes(input.toLowerCase())
          }
          options={issuerOptions}
        />
      </Form.Item>
      <Form.Item
        name="name"
        label="Даатгалын нэр"
        rules={[{ required: true, message: "Нэр оруулна уу" }]}
      >
        <Input placeholder="Жишээ: Автомашины багц даатгал" />
      </Form.Item>
      <Form.Item
        name="highlight"
        label="Тайлбар нэршил"
        rules={[{ required: true, message: "Тайлбар нэршил өгнө үү" }]}
      >
        <Input placeholder="2–3 үг (жишээ: Авто зориулсан)" />
      </Form.Item>
      <Form.Item
        name="categoryId"
        label="Даатгалын төрөл"
        rules={[{ required: true, message: "Ангилал сонгоно уу" }]}
      >
        <Select
          allowClear
          placeholder="Машин / Амьдрал / Орон сууц / Эрүүл мэнд / Аялал"
          options={categoryOptions}
        />
      </Form.Item>
      <Form.Item
        name="rating"
        label="Үнэлгээ (rating)"
        rules={[{ required: true, message: "Үнэлгээ өгнө үү" }]}
      >
        <InputNumber
          prefix={<IconStar size={16} color="#e68200ff" />}
          min={0}
          max={5}
          step={0.1}
          placeholder="4.5"
          style={{ width: "100%" }}
        />
      </Form.Item>
      <Form.Item name="applyUrl" label="Дэлгэрэнгүй / Захиалах холбоос">
        <Input placeholder="https://..." />
      </Form.Item>
      <Form.Item
        name="featured"
        label="Нүүрэнд онцлох"
        valuePropName="checked"
        initialValue={false}
      >
        <Switch />
      </Form.Item>
    </>
  );
}
